// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","left":"Footer_left__4fSdk","right":"Footer_right__3yQE6"};